export default __webpack_public_path__ + "static/media/QuestionnaireImage.a3c35bef.svg";